// Helper function to parse CSV data
export const parseCSV = (csvData) => {
    const lines = csvData.split('\n');
    const result = [];
    const headers = lines[0].split(',');

    for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentLine = lines[i].split(',');

        headers.forEach((header, index) => {
            obj[header] = currentLine[index];
        });

        result.push(obj);
    }

    return result;
};
